import React from "react";
import { useField } from "formik";
import classNames from "classnames";
import { CustomSelect } from "../../../../forms/CustomSelect/CustomSelect";
import {
    DateConditionType,
    TransactionRuleConditionFormSchema,
} from "../constants";
import styles from "../RuleForm.module.scss";
import { RuleConditionDate } from "../../../../../common/types/transactionRule";
import { DatePickerInput } from "../../../../forms/dates/DatePickerInput/DatePickerInput";

interface Props {
    condition: TransactionRuleConditionFormSchema;
    index: number;
}

const conditionTypesOptions = Object.values(DateConditionType).map((v) => ({
    value: v,
}));

export const DateConditionForm: React.FC<Props> = ({ condition, index }) => {
    const [conditionTypeField, , conditionTypeHelpers] = useField<
        TransactionRuleConditionFormSchema["dateConditionType"]
    >(`conditions.${index}.dateConditionType`);
    const [valueRangeField, , valueRangeHelpers] = useField<
        TransactionRuleConditionFormSchema["dateValueRange"]
    >(`conditions.${index}.dateValueRange`);

    const setRangeValue = (
        value: string | undefined,
        key: keyof RuleConditionDate,
    ) => {
        valueRangeHelpers.setValue({
            ...(valueRangeField.value ?? {}),
            [key]: value,
        });
    };

    return (
        <>
            <CustomSelect
                value={conditionTypeField.value}
                onSelected={(v) => conditionTypeHelpers.setValue(v)}
                dropdownKey={`dateConditionType${condition.id}`}
                placeholder="Select type"
                size="xs"
                options={conditionTypesOptions}
            />
            {conditionTypeField.value === DateConditionType.AFTER && (
                <DatePickerInput
                    name={`conditions.${index}.dateValueRange.after`}
                    value={valueRangeField.value?.after ?? ""}
                    onChange={(v) => setRangeValue(v, "after")}
                    inputClassName={classNames(
                        "form-control",
                        "form-control-xs",
                        styles.dateInput,
                    )}
                />
            )}
            {conditionTypeField.value === DateConditionType.BETWEEN && (
                <>
                    <DatePickerInput
                        name={`conditions.${index}.dateValueRange.after`}
                        value={valueRangeField.value?.after ?? ""}
                        onChange={(v) => setRangeValue(v, "after")}
                        inputClassName={classNames(
                            "form-control",
                            "form-control-xs",
                            styles.dateInput,
                        )}
                    />
                    and
                    <DatePickerInput
                        name={`conditions.${index}.dateValueRange.before`}
                        value={valueRangeField.value?.before ?? ""}
                        onChange={(v) => setRangeValue(v, "before")}
                        inputClassName={classNames(
                            "form-control",
                            "form-control-xs",
                            styles.dateInput,
                        )}
                    />
                </>
            )}
        </>
    );
};
